import React, { useState, useEffect } from 'react';
import { useZxing } from 'react-zxing';
import { useModal } from './utils';
import { useTranslation } from 'react-i18next';

const ScannerModal = ({ isOpen, onClose, onScan }) => {
  const { t } = useTranslation();
  const [result, setResult] = useState("");
  const [paused, setPaused] = useState(true);
  const [scanSound] = useState(new Audio('/assets/sound/scan.wav'));
  const {
    ref,
    torch: {
      on: torchOn,
      off: torchOff,
      isOn: isTorchOn,
    },
  } = useZxing({
    paused,
    onDecodeResult(result) {
      setResult(result.getText());
      onScan(result.getText()); 
      scanSound.play();
      document.getElementById('barcode').style.backgroundColor = 'lightgreen';
    },
    onDecodeError(error) {
      //console.log(error);
    },
    onError(error) {
      //console.error(error);
    },
  });
  if (paused) {
    setTimeout(() => setPaused(false), 500);
  }
  return (
    <>
      <video ref={ref} style={{ maxWidth: '100%' }} />
      <p>
        <span>{t('HOME_SCAN_RESULT')}
          <input type="text" id='barcode' readOnly value={result} style={{fontWeight: "bold"}}/></span>
      </p>
    </>
  );
};

export default ScannerModal;


// Utilisation avec votre ScannerModal
const ScannerWrapper = ({ onScan }) => {
  const [internalResult, setInternalResult] = useState(null);
  const { closeModal } = useModal(); // Utilise le contexte du modal

  useEffect(() => {
    if (internalResult) {
      onScan(internalResult);
      // Fermeture automatique optionnelle
      // closeModal();
    }
  }, [internalResult, onScan]);

  return (
    <ScannerModal
      onScan={(result) => {
        setInternalResult(result); // Capture locale d'abord
        console.log("Résultat dans ScannerWrapper:", result);
      }}
      onError={(error) => console.error('Erreur scan:', error)}
    />
  );
};
export { ScannerWrapper };
